import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const SEARCH_ADMIN_INITIAL: SEARCH_ADMIN_QUERY = {
  search: "",
  searchType: "user",
  searchResults: [],
};

const searchAdminSlice = createSlice({
  name: "searchAdmin",
  initialState: {
    ...SEARCH_ADMIN_INITIAL,
  },
  reducers: {
    SEARCH_ADMIN_UPDATE: (
      state,
      action: PayloadAction<{
        data?: SEARCH_ADMIN_QUERY;
        prop?: string;
        value?: string | Number | Object | [];
      }>,
    ) => {
      // console.log("SEARCHING", action.payload);
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { SEARCH_ADMIN_UPDATE } = searchAdminSlice.actions;

export { searchAdminSlice, SEARCH_ADMIN_INITIAL, SEARCH_ADMIN_UPDATE };
